import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../services/supabaseClient'

export function ExtensionConnectPage() {
  const { sessionUserId } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!sessionUserId) {
      navigate('/', { replace: true })
      return
    }

    const connectExtension = async () => {
      try {
        // Generate a random 64-char hex code
        const bytes = new Uint8Array(32)
        crypto.getRandomValues(bytes)
        const code = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')

        // Insert into extension_codes (RLS allows users to insert own codes)
        const { error: insertError } = await supabase
          .from('extension_codes')
          .insert({ user_id: sessionUserId, code })

        if (insertError) {
          console.error('Failed to insert extension code:', insertError)
          setError('Failed to generate connection code. Please try again.')
          return
        }

        // Redirect to callback page with code in URL
        navigate(`/extension/callback?code=${code}`, { replace: true })
      } catch (err) {
        console.error('Extension connect error:', err)
        setError('Something went wrong. Please try again.')
      }
    }

    connectExtension()
  }, [sessionUserId, navigate])

  if (error) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="rounded-xl border border-rose-200 dark:border-rose-900/40 bg-rose-50 dark:bg-rose-950/30 p-6 text-center max-w-md">
          <p className="text-rose-700 dark:text-rose-200 text-sm">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 rounded-lg bg-app-primary px-4 py-2 text-sm font-medium text-white hover:bg-app-primary-hover transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-sky-500 border-r-transparent" />
        <p className="mt-4 text-sm text-app-muted">Connecting extension...</p>
      </div>
    </div>
  )
}
